export default "__VITE_PUBLIC_ASSET__377a6978__"